<template>
  <div>
    <p v-html="txtNotice" />
  </div>
</template>
<script>
import Api from '@libraries/api/'
import RequestSameHeroes from '@requests/same-heroes'
import localeVote from '@locales/vote'
import { validatelocale } from '@constants'

export default {
  name: 'voteSeriesMergeNotice',
  $messages: localeVote,
  props: {
    hero: {
      type: Object,
      required: true,
    }
  },
  computed: {
    excludeOwnSeries() {
      if (!this.sameHeroes) return
      return this.sameHeroes.filter(h => h.id !== this.hero.id).map(h => h.seriesName)
    },
    txtNotice(){
      if (!this.sameHeroes) return
      if (this.isSameSeries) {
        // 同一シリーズに別バージョンキャラが存在する場合
        const hero = this.sameHeroes.find(hero => hero.id !== this.hero.id)
        const seriesName = this.excludeOwnSeries.map(s => `${hero.name} (${s})`).join(', ')
        return this.$t('text001', {series_name: seriesName})
      } else {
        // 異なるシリーズに同名キャラが存在する場合
        const seriesName = this.excludeOwnSeries.map(s => `${this.hero.name} (${s})`).join(', ')
        return this.$t('text001', {series_name: seriesName})
      }
    },
    isSameSeries() {
      const first = this.sameHeroes[0]
      return this.sameHeroes.every(hero => hero.seriesId === first.seriesId)
    }
  },
  data() {
    return {
      sameHeroes: null,
    }
  },
  created(){
    if (this.hero.isSamePerson) {
      this.getSameHeroes(this.hero.baseHeroId)
    }
  },
  watch: {
    'hero'(){
      if (this.hero.isSamePerson) {
        this.getSameHeroes(this.hero.baseHeroId)
      }
    }
  },
  methods: {
    async getSameHeroes(baseHeroId){
      //MEMO: cookie と path のlocaleが同じかどうかをチェック エラー時には強制リロード
      const cookieCheck = await validatelocale(this.$route.params.lang)
      if (cookieCheck) {
        Api.call(new RequestSameHeroes({baseHeroId}))
        .then((sameHeroes) => {
          this.sameHeroes = sameHeroes
        })
        .catch(({error}) => {
          throw error
        })
      } else {
        location.reload()
      }
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
